import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { server } from '../server'
import Swal from 'sweetalert2'
import OtpModal from '../Templates/OtpModal';


import { Company_Id } from '../Helper'
import { Corporate_Id } from '../Helper'
import { Corporate_Name } from '../Helper'
import { Vendor_Id } from '../Helper'
import { Vendor_Name } from '../Helper'
import { en } from 'faker/lib/locales';

function Registration() {
  //================ Local record ==================
  // const initialValues = {
  //   Name: "", Email: "", MobileNo: "", Gender: "", DeviceTokenId: "0", DeviceType: "o3web",
  //   UserPass: "", UserConfirmPass: "",
  //   CorporateId: "13611", CorporateName: "O3MPLRetail",VendorId:"2584"
  // }

  //========== Live record ==============
  const initialValues = {
    Name: "", Email: "", MobileNo: "", Gender: "", DeviceTokenId: "0", DeviceType: "o3web",
    UserPass: "", UserConfirmPass: "",
    CorporateId: "-1", CorporateName: "",VendorId:"2583",EmployeeID:"",CompanyId:"-1",OTP:""
  }

const [showModal, setShowModal] = useState(false);
const [isRegistering, setIsRegistering] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);


  const [formvalue, setFormValue] = useState(initialValues);

  const [SelectedCorporate, setSelectedCorporate] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [IsSubmit, setIsSubmit] = useState(false);
const [EnteredOTP, setEnteredOTP] = useState(false);
  const handChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formvalue, [name]: value });
     if (name === 'CorporateId') {
    setSelectedCorporate(value);
    
    console.log('Selected Corporate ID:', value);
  }
    // console.log(formvalue);
  }


// const handChange = (e) => {
//   const { name, value } = e.target;

//   // Get the selected option's text for CorporateName
//   const selectedText = e.target.options[e.target.selectedIndex].text;

//   if (name === 'CorporateId') {
//     setFormValue(prev => ({
//       ...prev,
//       CorporateId: value,
//       CorporateName: selectedText
//     }));
//     setSelectedCorporate(value); // optional if still needed separately
//   } else {
//     setFormValue(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   }
// };



  // useEffect(() => {
  //   //console.log(formErrors);
  //   if (Object.keys(formErrors).length == 0 && IsSubmit && EnteredOTP=== true) {
  //     alert(EnteredOTP);
  //     userRegistration(formvalue);
  //   }
  // }, [EnteredOTP]);
const verifyOtp = (otp) => {
    if (otp.length === 6) {
      formvalue.OTP = otp;
      setEnteredOTP(true);
      userRegistration({ ...formvalue });
      // closeModal();
    } else {
      alert("Invalid OTP. Please enter a 6-digit code.");
    }


    
  };
  // async function userRegistration(formvalue) {
  //   // formvalue.otp = '';

  //   if (showModal=== true) {
  //     //  alert(showModal);
  //     formvalue.OTP = formvalue.OTP;
  //   }
  //   else {
  //     formvalue.OTP = '';
  //   }

  //     // console.log(formvalue);
  // // formvalue.otp = otp;
  //   let result = await fetch(`${server}/api/Siemens/Registration`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Accept": "application/json"
  //     },
  //     credentials: "include", 
  //     body: JSON.stringify(formvalue)

  //   });
  //   result = await result.json();
  //   //  if(result)

  //   // if (result.statusCode === 200) {
  //   //   Swal.fire(
  //   //     'Successfully Done!',
  //   //     'Thank you for registration, User ID and Password will be sent to your registered email id',
  //   //     'success'
  //   //   )
  //   // }
  //   if (result.statusCode == 200 && result.status == 'Email/EmployeeId Already Exist') {
  //     Swal.fire(
  //       'Invalid Input!',
  //       'Email/EmployeeId Already Exist',
  //       'error'
  //     )
  //   }
  //   if (result.statusMessage == 'Mobile No. Already Exist') {
  //     Swal.fire(
  //       'Error!',
  //       'Mobile No Already Registered',
  //       'error'
  //     )
  //   }
  //   if (result.status == 'Invalid Email') {
  //     Swal.fire(
  //       'Error!',
  //       'Email Subdomain is not valid',
  //       'error'
  //     )
  //   }

  //   // Invalid OTP
  //   if (result.status == 'OTP Sent to Emaial') {
  //     openModal();
  //   }
  //   if (result.status == 'Invalid OTP') {
  //     Swal.fire(
  //       'Error!',
  //       'Invalid OTP, please Enter a Valid OTP',
  //       'error'
  //     )
  //   }
  //   if (result.status == 'Inserted Successfully') {
     
  //     Swal.fire(
  //       'Success',
  //       'Registered Successfully User ID and Password will be sent to your registered email id',
  //       'success'
  //     )
  //      closeModal();
  //     setEnteredOTP(false);
  //     setFormValue(initialValues);
       
  // //     setTimeout(() => {
  // //       console.log("Reloading page...");

  // //   window.location.reload();
  // // }, 7000);
  //   }
    


  //   // console.log(result.statusCode);
  // }

async function userRegistration(formvalue) {
  setIsRegistering(true); // Start loading spinner

  try {
    if (showModal === true) {
      formvalue.OTP = formvalue.OTP;
    } else {
      formvalue.OTP = '';
    }

    

    const selectedcorporatename = document.getElementById('corporateSelect');
    formvalue.CorporateName = selectedcorporatename.options[selectedcorporatename.selectedIndex].text;

 


    let result = await fetch(`${server}/api/Siemens/Registration`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      // credentials: "include",
      body: JSON.stringify(formvalue)
    });

    result = await result.json();

    if (result.statusCode == 200 && result.status === 'Email/EmployeeId Already Exist') {
      Swal.fire('Invalid Input!', 'Email/EmployeeId Already Exist', 'error');
    } else if (result.statusMessage === 'Mobile No. Already Exist') {
      Swal.fire('Error!', 'Mobile No Already Registered', 'error');
    } else if (result.status === 'Invalid Email') {
      Swal.fire('Error!', 'Email Subdomain is not valid', 'error');
    } else if (result.status === 'OTP Sent to Emaial') {
      openModal();
    } else if (result.status === 'Invalid OTP') {
      Swal.fire('Error!', 'Invalid OTP, please Enter a Valid OTP', 'error');
    } else if (result.status === 'Inserted Successfully') {
      Swal.fire('Success', 'Registered Successfully. User ID and Password will be sent to your registered email id', 'success');
      closeModal();
      setEnteredOTP(false);
      setFormValue(initialValues);
    }
  } catch (error) {
    Swal.fire('Network Error', 'Something went wrong. Please try again later.', 'error');
  } finally {
    setIsRegistering(false); // Stop loading spinner
  }
}


  const handleSubmit = (e) => {
    e.preventDefault();

    setFormErrors(validate(formvalue));
    setIsSubmit(true);
  }
  useEffect(() => {
    //console.log(formErrors);
    // alert(EnteredOTP);
    // alert(showModal);
    if (Object.keys(formErrors).length == 0 && IsSubmit && EnteredOTP=== false && showModal=== false) {
      // alert(EnteredOTP);
      userRegistration(formvalue);
    }
  }, [formErrors]);

  const validate = (value) => {
    const errors = {};
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const mobileNoRegex = /^[0-9]{10}$/; // Adjust the pattern as needed

    if (!value.Name) {
      errors.Name = "Name is required";
    }
    if (!value.Email) {
      errors.Email = "Email required";
    } else if (!emailRegex.test(value.Email)) {
      errors.Email = "This is not a valid email format";
    }
// formErrors.EmployeeID
// if (!value.EmployeeID) {
//       errors.EmployeeID = "Employee Id is required";
//     }
    if (!value.MobileNo) {
      errors.MobileNo = "Mobile No. required";
    } else if (!mobileNoRegex.test(value.MobileNo)) {
      errors.MobileNo = "Invalid Mobile No.";
    }
      if (!value.Gender) {
        errors.Gender = "Gender required";
      }

// formErrors.CorporateId 
    if (!value.CorporateId || value.CorporateId === "-1") {
      errors.CorporateId = "Corporate is required";
    }

    if (!value.UserPass) {
      errors.UserPass = "Password is required";
    } else if (value.UserPass.length < 8) {
      errors.UserPass = "Password must be at least 8 characters long";
    }
    if (!value.UserConfirmPass) {
      errors.UserConfirmPass = "Confirm password is required";
    } 
     if (value.UserPass && value.UserPass !== value.UserConfirmPass) {
      errors.UserConfirmPass = "Passwords do not match";
      // alert("Password do not match");
    }
  // console.log(errors);
    return errors;
  };

  return (
    <div>
      <div className='hold-transition login-page'>  

        <form onSubmit={handleSubmit}>
          <div className="login-box">
            <div className="card card-outline card-warning">
              <div className="card-header text-center">
                <img src="https://invoice.eveelz.in/invoice?q=driverapp/1747225392109_eveelz_logo_latest.png" alt="logo" style={{ width: '200px' }} />
              </div>
              <div className="card-body">

                {
                  // Object.keys(formErrors).length==0 && IsSubmit ? (
                  //   <div className="alert alert-success">Register Successfully</div>
                  //   ): (
                  //     <div></div>
                  //    )
                }

                <p className="login-box-msg">Register</p>
                <form >
                  <div className="input-group mb-1">
                    <input type="text" id='username' className="form-control" placeholder="Name"
                      name="Name"
                      value={formvalue.Name}
                     onChange={(e) => {
    const value = e.target.value.replace(/[0-9]/g, ""); // ✅ Removes numbers
    handChange({ target: { name: "Name", value } });
  }}


                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-user" />
                      </div>
                    </div>

                  </div>

                  
                  <p className='text-danger'>{formErrors.Name}</p>
                  <div className="input-group mb-3">
                    <input type="email" id='useremail' className="form-control" placeholder="Email"
                      name="Email"
                      value={formvalue.Email}
                      onChange={handChange}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-envelope" />
                      </div>
                    </div>
                  </div>

                  <p className='text-danger'>{formErrors.Email}</p>
                  <div className="input-group mb-3">
                    <input id='usermobileno' type="text" className="form-control" placeholder="Mobile No"
                      name="MobileNo"
                      value={formvalue.MobileNo}
                      onChange={(e) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); 
    if (value.length <= 10) { 
        handChange({ target: { name: "MobileNo", value } });
    }
  }}

                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fa fa-mobile" />
                      </div>
                    </div>
                  </div>
                  <p  className='text-danger'>{formErrors.MobileNo}</p>
                  <div className="input-group mb-3"></div>
{/* <div className="input-group mb-3">
                    <input id='usermobileno' type="text" className="form-control" placeholder="Employee ID"
                      name="EmployeeID"
                      value={formvalue.EmployeeID}
                      onChange={handChange}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fa fa-mobile" />
                      </div>
                    </div>
                  </div> */}


                  <p className='text-danger'>{formErrors.EmployeeID}</p>
                  <div className="input-group mb-3">
                    {/* <input type="password" className="form-control" placeholder="Password" />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-lock" />
                    </div>
                  </div> */}
                    <select id='usergender' className="form-control"
                      name="Gender"
                      value={formvalue.Gender}
                      onChange={handChange}
                    >
                      <option>Select your Gender</option>
                      <option>Male</option>
                      <option>Female</option>
                    </select>

                  </div>
                  <p className='text-danger'>{formErrors.Gender}</p>


<div className="input-group mb-3">
  <select
    id="corporateSelect"
    className="form-control"
    name="CorporateId"
    value={formvalue.CorporateId}
    onChange={handChange}
  >      
 
    <option value="-1">Select Corporate</option>
    <option value="11337">Siemens Ltd</option>
    <option value="13708">Siemens Technology Service Pvt Ltd</option>
    <option value="13709">Siemens Healthineers India LLP</option>
    <option value="13710">Siemens Healthcare Private Limited</option>
    <option value="13711">Siemens Energy India Limited</option>
    <option value="13712">Siemens financial Services Pvt Ltd</option>
    <option value="13713">Siemens Rail Automation Pvt. Ltd.</option>
    <option value="13714">SIEMENS FACTORING PRIVATE LIMITED</option>
    <option value="13764">Siemens Industry Software(India)Pvt.Ltd</option>
    <option value="13765">Siemens EDA India Pvt Ltd</option>
    <option value="13766">Siemens EDA (Sales & Services) Pvt Ltd</option>
  </select>
</div>
<p className="text-danger">{formErrors.CorporateId}</p>

                  <div className="input-group mb-3">
                    <input id='userpassword' type="password" className="form-control" placeholder="Password"
                      name="UserPass"
                      value={formvalue.UserPass}
                      onChange={handChange}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-lock" />
                      </div>
                    </div>
                  </div>
                  <p className='text-danger'>{formErrors.UserPass}</p>
                  <div className="input-group mb-3">
                    <input id='userconfirmpassword' type="password" className="form-control" placeholder="Confirm Password"
                      name="UserConfirmPass"
                      value={formvalue.UserConfirmPass}
                      onChange={handChange}
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-lock" />
                      </div>
                    </div>
                  </div>
                  <p className='text-danger'>{formErrors.UserConfirmPass}</p>
                  <div className="row">

                    <div className="col-8">
                      {/* <p className='text-danger'>{formErrors.UserConfirmPass}</p> */}
                      <div className="icheck-primary">
                        <input type="checkbox" id="remember" />
                        <label htmlFor="remember">
                          Remember Me
                        </label>
                      </div>
                    </div>

                    <div className="col-4">
                      <Link to="/" className="">Login</Link>
                    </div>
                  </div>
                </form>
                <div className="social-auth-links text-center mt-2 mb-3">
                </div>

                {/* <p className="mb-0">
                  <button className="btn btn-warning btn-block">Register Now</button>
                </p> */}
                <p className="mb-0">
  <button
    className="btn btn-warning btn-block"
    // onClick={handleRegisterClick}
    disabled={isRegistering}
  >
    {isRegistering ? (
      <>
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Registering...
      </>
    ) : (
      'Register Now'
    )}
  </button>
</p>

                <div className="container mt-5">
      {/* <button className="btn btn-success" onClick={openModal}>Enter OTP</button> */}
      <OtpModal show={showModal} handleClose={closeModal} verifyOtp={verifyOtp} />
    </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
export default Registration
